import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useRecoilState ,useRecoilValue} from 'recoil';//取得のみ
import { configJsonState } from "../../states/configJsonState";
import { TweetButton } from '../06mypage/tweetButton';
import { VStack } from '@chakra-ui/react';
// import { TweetButton } from '../06mypage/tweetButtonComponent';


type Props = {
    imageUrl: string,
}
export const NFTImageDisplay: React.FC<Props> = (props) => {
  const configStatus = useRecoilValue(configJsonState);
  const [t, i18n] = useTranslation();
  const NFTImageDisplayComponent = styled.div`
  `;
  const NFTImage = styled.img`
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;
    margin-bottom: 20px;
    margin-top: 7px;
    border: 6px solid;
    border-image: conic-gradient(#f5f551,#5eff5e,#84a1ff,#ff45ff,#ff5a5a,#ffbc41,#f5f551) 1;
    
    display: unset;

    @media (max-width: 2560px) {
      width: 20%;
      height: 20%;
    }
    @media (max-width: 768px) {
      width: 55%;
      height: 55%;
    }
`;

  const pTagStyle: React.CSSProperties = {
    marginTop:'50px',
    fontWeight: 'bold',
    fontSize: '20px',
  };
  return (
    <NFTImageDisplayComponent>
        <p style={pTagStyle}>{t('NFTの保存完了！')}</p>
        <VStack spacing={`20px`}>
          {configStatus.isTweetButton === `yes` && <TweetButton/>}
          <NFTImage src={props.imageUrl} />
        </VStack>
    </NFTImageDisplayComponent>
  );
};